export default theme => ({
  alertsCollapsedText: {
    fontSize: "16px !important",
  },
  centeredText: {
    "text-align": "center",
    marginTop: theme.spacing(3),
    color: theme.palette.link.main,
  },
});
